var exports = {
  "JU": "Label__iv6s0H",
  "az": "Box__qgUXXu",
  "xn": "RoadmapCell__BTAG-C",
  "EB": "leadingEdge__1evSI9",
  "I0": "visiblePill__z6_XVv",
  "XW": "pillContent__TpNQds",
  "Ym": "pillContentWithLeadingEdge__SX_SlA",
};

module.exports = exports;
